import { useQuery } from '@apollo/client';
import { isEmpty } from '@newfront-insurance/core';
import { useMemo } from 'react';

import { useSkillsSafe } from '../components/chat-v2/contexts/skills-context';
import { buildSkillCommands } from '../lib/skill-constants';
import { GET_SKILLS_FOR_USER, type NovaSkill } from '../queries/chats';

interface UseSkillCommandsOptions {
  accountUuid?: string;
  userUuid?: string;
  preferContext?: boolean;
}

export function useSkillCommands({ accountUuid, userUuid, preferContext = true }: UseSkillCommandsOptions) {
  const skillsContext = useSkillsSafe();
  const activeSkillsContext = preferContext ? skillsContext : undefined;

  const skillsQuery = useQuery(GET_SKILLS_FOR_USER, {
    variables: { userUuid: userUuid!, accountUuid },
    skip: Boolean(activeSkillsContext) || isEmpty(userUuid),
    fetchPolicy: 'cache-and-network',
  });

  const skills = useMemo<NovaSkill[]>(
    () => activeSkillsContext?.skills ?? skillsQuery.data?.skills ?? [],
    [activeSkillsContext, skillsQuery.data?.skills],
  );
  const commands = useMemo(() => buildSkillCommands(skills), [skills]);
  const isSkillsLoading = activeSkillsContext?.isLoading || skillsQuery.loading;
  const skillsError = activeSkillsContext?.error ?? skillsQuery.error;

  return {
    commands,
    skills,
    isLoading: isSkillsLoading,
    error: skillsError,
  };
}
